import React, { useState } from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';
import { Plus } from 'lucide-react';
import { useEffect } from 'react';
import faqService from '../../services/faq.service';
import './FaqQuestionsConfig.css';
import NewFaqQuestionModal from './NewFaqQuestionModal/NewFaqQuestionModal';
import ConfirmModal from '../ConfirmModal';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { getError } from '../../utils';
import { Button } from '../ui/button';

export default function FaqQuestionsConfig() {
  const { t } = useTranslation();
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [loadQuestions, setLoadQuestions] = useState(true);
  const [deleteShow, setDeleteShow] = useState(false);
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    const fetchQuestions = async () => {
      if (loadQuestions) {
        try {
          const fetchedQuestions = await faqService.getFaqs();
          setQuestions(fetchedQuestions);
        } catch (ex) {
          console.error(ex);
        }
        setLoadQuestions(false);
      }
    };
    fetchQuestions();
  }, [loadQuestions]);

  const handleOpen = () => setShow(true);
  const handleEdit = question => {
    setSelectedQuestion(question);
    setEdit(true);
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setDeleteShow(false);
    setEdit(false);
    setLoadQuestions(true);
    setSelectedQuestion(null);
  };
  const handleSelectDeletion = q => {
    setSelectedQuestion(q);
    setDeleteShow(true);
  };

  const handleDeleteQuestion = async () => {
    try {
      await faqService.deleteFaq(selectedQuestion._id);
      toast.success(t('faq.questionDeleted'));
      handleClose();
    } catch (ex) {
      toast.error(getError(ex));
      console.error(ex);
    }
  };

  return (
    <div id='faq-config'>
      <ConfirmModal
        show={deleteShow}
        onHide={() => setDeleteShow(false)}
        onConfirm={handleDeleteQuestion}
        title={t('faq.deleteQuestion')}
        message={t('faq.confirmDelete')}
        confirmLabel={t('common.delete')}
        cancelLabel={t('common.cancel')}
      />
      <NewFaqQuestionModal
        show={show}
        handleClose={handleClose}
        edit={edit}
        editQuestion={selectedQuestion}
      />

      <Button size='sm' onClick={handleOpen}>
        <Plus className='h-4 w-4 mr-1.5' />
        {t('faq.addQuestion') || 'Nueva pregunta'}
      </Button>

      <div className='container ps-0 mt-2'>
        <ul className='space-y-1.5' id='lista-preguntas'>
          {questions.length > 0 &&
            questions.map((q, index) => (
              <li
                key={index}
                id={q._id}
                className='flex items-center justify-between rounded-md border border-border bg-background px-4 py-3 text-sm text-foreground'
              >
                <span className='flex-1'>{q.question}</span>
                <div className='flex items-center gap-2'>
                  <Button
                    variant='ghost'
                    size='icon-sm'
                    onClick={() => handleEdit(q)}
                    title={t('common.edit')}
                  >
                    <FaPen />
                  </Button>
                  <Button
                    variant='ghost'
                    size='icon-sm'
                    onClick={() => handleSelectDeletion(q)}
                    title={t('common.delete')}
                  >
                    <FaTrash />
                  </Button>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
